import BasicLayout from "@components/layouts/basic";
import Login from "@components/login";
import { Box, Container } from "@material-ui/core";
import { useRouter } from "next/router";
import React from "react";

export default function Page() {
  const router = useRouter();
  const returnTo = router.query.returnTo as string;

  return (
    <BasicLayout title="Login">
      <Container maxWidth="sm">
        <Box py={4}>
          <Login returnTo={returnTo} />
        </Box>
      </Container>
    </BasicLayout>
  );
}
